import React from 'react'

function Kids() {
    return (
        <div className='text-center my-20'>
            <h1 className='font-bold text-2xl'>Comming Soon .....</h1>
        </div>
    )
}

export default Kids
